import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { CommonLibModule } from '@nrwl/common-lib';
import { CommonMaterialModule } from '@nrwl/common-material';
import { authenticationRoutes } from "./authentication.routing";
import { Globals } from "./authentication.globals";
import { SigninComponent } from './components/signin/signin.component';

/*services*/
import { PasswordCountPipe } from "./pipes/password.count.pipe";
import { PasswordStrengthDirective } from "./directives/password.strength/password.strength.directive";

@NgModule({
  imports: [
    CommonModule,
    CommonLibModule,
    CommonMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(authenticationRoutes)
  ],
  declarations: [
    SigninComponent,
    PasswordStrengthDirective,
    PasswordCountPipe
  ],
  exports: [
    PasswordCountPipe,
    PasswordStrengthDirective
  ],
  providers: [
    Globals
  ]
})
export class FusionAuthenticationModule { }
